import ReactGA4 from 'react-ga4';
import {JWT_TOKENEXPIRE_SECONDS} from '../auth/constants';
import {IS_CLIENT_SIDE} from '../common/shared/utils/constants';
import {GA_TRACKER_NAME, GA_TRACKING_CODE} from './constants';

export function initGoogleAnalytics() {
  if (!IS_CLIENT_SIDE || window.ga) {
    return;
  }
  ReactGA4.initialize(GA_TRACKING_CODE, {
    gaOptions: {
      name: GA_TRACKER_NAME,
      cookieDomain: 'page.kakao.com',
      cookieName: 'page.kakao.com',
      cookieExpires: JWT_TOKENEXPIRE_SECONDS,
      send_page_view: false,
    },
  });
}
